import React from "react";
import "./hierarchy.css";

export default function ParokiaModal({ parokia, onClose }) {
  return (
    <div className="modal-overlay">
      <div className="modal small">
        <div className="modal-header">
          <h3>Parokia Details</h3>
          <button className="close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal-body">
          <p><strong>Name:</strong> {parokia?.name}</p>
          <p><strong>Bank Ref:</strong> {parokia?.bank_ref || "-"}</p>
        </div>
      </div>
    </div>
  );
}
